module.exports = __webpack_public_path__ + "static/techinasia-gojek-10c3f444f3c7e76aaa3b3af189efef21.jpg";